/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import useSteps from '../StepContext/useSteps';
import { dietSettingsGetStepsCountForCurrentStep } from '../utils/DietSettingsStepsCountAction';
import { dietSettingsGetCurrentStepPositon } from '../utils/DietSettingsGetCurrentStepPositionAction';
import { Progress } from 'reactstrap';
import { useFormikContext } from 'formik';
import { goalSettings } from '../types';

const ProgressBar: React.FC = () => {
  const { currentStep, schema } = useSteps();
  const { values } = useFormikContext<goalSettings>();
  const [progress, setProgress] = useState<number>();

  const dietSettingsGetProgress = () => {
    const stepsCount = dietSettingsGetStepsCountForCurrentStep(schema, values, currentStep);
    const currentStepPositon = dietSettingsGetCurrentStepPositon(schema, values, currentStep);

    return Math.round((100 / stepsCount) * currentStepPositon);
  };

  useEffect(() => {
    setProgress(dietSettingsGetProgress());
  }, [currentStep]);

  return <Progress value={progress} />;
};

export default ProgressBar;
